<template>
    <div data-cy="utilsContent-div-content" class="position-relative util-content pa-4">
        <slot name="header"></slot>
        <slot name="content"></slot>
        <slot name="actions"></slot>
    </div>
</template>
<script>
export default {
    name: 'UtilsContent',
    props:{
        contentWidth: {type: [String, Number], default: '35'},
        contentWidthUnit: {type: String, default: 'vw'}
    },
    computed: {
        size(){
            return `${this.contentWidth}${this.contentWidthUnit}`
        }
    },
    methods: {
        click() {
            this.$emit('close-action')
        },
    },
}
</script>
<style lang="scss">
.util-content {
    background: #ffffff;
    border-radius: 1rem 1rem 0 0;
    // border: 1.5px solid #4bada1;
    // margin-right: -1em;
    z-index: 4;
}
.reading-card{
    .util-content{
        border-radius: 1rem;
        min-width: 400px;
        width: 50vw;
        @media screen and (min-width: 1600px) {
            width: 45vw;
        }
        @media screen and (min-width: 1900px) {
            width: 40vw;
        }
    }
}
.btn-close {
    top: -1rem;
    left: -1rem;
}

</style>
